<template>
  <section id="contact" class="section bg-primary">
    <div class="container">
      <div v-for="(contact, idx) in data.contact" :key="idx" class="row">
        <div class="col-lg-5 text-center text-lg-start wow fadeInUp" style="visibility: visible; animation-name: none;">
          <h2 class="text-10 fw-600 mb-5">Let's get in touch</h2>
          <p class="text-5 mb-5">I enjoy discussing new projects and design challenges. Please share as much info, as
            possible so we can get the most out of our first catch-up.</p>
          <h3 class="text-5 fw-600">Living In:</h3>
          <address class="text-4">
            {{contact.city}}
          </address>
          <h3 class="text-5 fw-600">Call:</h3>
          <p class="text-4">{{contact.phone}}</p>
          <ul class="social-icons social-icons-lg justify-content-center justify-content-lg-start mt-5">
            <!-- <li class="social-icons-twitter">
              <a data-bs-toggle="tooltip" 
              :href="contact.twitter" 
              target="_blank" title data-bs-original-title="Twitter"><i
                class="fab fa-twitter"></i></a></li> -->
            <li class="social-icons-facebook"><a data-bs-toggle="tooltip" 
              :href="contact.facebook"
              target="_blank" title data-bs-original-title="Facebook"><i
                class="fab fa-facebook"></i>
              </a>
            </li>
            <li class="social-icons-instagram">
              <a data-bs-toggle="tooltip" 
              :href="contact.instagram"
              target="_blank" title data-bs-original-title="Instagram"><i
                class="fab fa-instagram"></i>
              </a>
            </li>
            <li class="social-icons-github">
              <a data-bs-toggle="tooltip" 
              :href="contact.git" target="_blank"
              title data-bs-original-title="GitHub">
              <i class="fab fa-github"></i>
              </a>
            </li>
            <!-- <li class="social-icons-dribbble">
              <a data-bs-toggle="tooltip" 
             :href="contact.dribbble"
              target="_blank" title data-bs-original-title="Dribbble">
              <i class="fab fa-dribbble"></i>
              </a>
            </li> -->
          </ul>
        </div>
        <div class="col-lg-6 ms-auto mt-5 mt-lg-0 wow fadeInUp" data-wow-delay="0.3s"
             style="visibility: visible; animation-delay: 0.3s; animation-name: none;">
          <h2 class="text-10 fw-600 text-center text-lg-start mb-5">Estimate your Project?</h2>
          <!-- Contact Form -->
          <form  class="form-border"   action="https://formspree.io/f/mpzbowbk"
  method="POST">
            <div class="row g-4">
              <div class="col-12">
                <label class="form-label" for="name">What is Your Name:</label>
                <input id="name" name="name" type="text" class="form-control py-1" required>
              </div>
              <div class="col-12">
                <label class="form-label" for="email">Your Email Address:</label>
                <input id="email" name="email" type="email" class="form-control py-1" required>
              </div>
              <div class="col-12">
                <label class="form-label" for="form-message">How can I Help you?:</label>
                <textarea id="form-message" name="form-message" class="form-control py-1" rows="4" required></textarea>
              </div>
              <div class="col-12 text-center text-lg-start">
                <button  class="btn btn-dark rounded-0" type="submit">Send <span class="ms-3"><i
                    class="fas fa-arrow-right"></i></span></button>
              </div>
            </div>
          </form>
          <!-- Contact Form end -->
        </div>
      </div>
        
    </div>
    
  </section>
</template>
<script>
export default {
  name: 'contact',
  computed:{
    data(){
      return {
          contact:this.$store.state[this.$options.name].data,
      }
    }
  }
}
</script>